<div class="list-page kapea" style="max-width: 1300px">
  <app-asiakas-otsikko otsikko="Selaa asiakkaita" [asiakas]="asiakas()"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding: 10px; margin-bottom: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Asiakkaat (Lemonaid): <a [href]="laskuAsiakkaatEncodedUriObservable | async" target="_BLANK">{{ laskuAsiakkaatUriObservable | async }}</a>
      </div>
    </div>
  }

  <div class="ylaosan-kontrollit">
    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>Etsi asiakkaita</mat-label>
        <input type="text" matInput readonly (click)="avaaHaku()" (keydown.enter)="avaaHaku()" (keydown.space)="$event.preventDefault(); avaaHaku()" style="cursor: pointer" aria-label="Avaa asiakashaku" />
      </mat-form-field>
    </div>
  </div>

  <div style="position: relative">
    <mat-table matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="ulkoinenTunniste">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px">Ulk. tunniste</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 110px">{{ row.ulkoinenTunniste || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Nimi</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.nimi }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="ytunnus">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px">Y-tunnus</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 100px">{{ row.ytunnus || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="asiakastyyppi">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 90px">Tyyppi</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 90px">{{ row.asiakastyyppi === 'h' ? 'Henkilö' : 'Yritys' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="postitmp">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 180px">Toimipaikka</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 180px">{{ row.postitmp || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="sahkoinen">
        <mat-header-cell *matHeaderCellDef style="max-width: 180px">Verkkolasku</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 180px">{{ row.sahkoinenosoite?.sahkoinenOsoite || '–' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row (click)="avaa(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if ((rivienMaaraObservable | async) === 0 && (lataaObservable | async) === false) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center; color: #888">Ei asiakkaita.</div>
      </div>
    }
  </div>

  <mat-paginator [length]="rivienMaaraObservable | async" [pageSize]="20" [pageSizeOptions]="[20, 50, 200]"></mat-paginator>
</div>
<app-asiakasrekisteri-haku-lemonator [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-asiakasrekisteri-haku-lemonator>
